import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { generateColors, withBarSelection } from '../../dashboard-helpers';

interface DataType {
  count: number[];
  name: LangType[];
}

export const useOrdersByEmployee = (): ChartProps => {
  const { t, getLocale } = useLang();

  const { list } = useDashboardStore();
  const data = list?.orders_by_employee as DataType;

  const chartData: ReactApexChartProps = useMemo(() => {
    const series = data?.count.length ? [{ name: t('Заказы'), data: data.count }] : [];
    const categories = data?.name.map((name) => getLocale(name)) || [];
    const colors = generateColors(categories.length);

    return {
      series,
      options: {
        chart: {
          type: 'bar',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 6.426,
            borderRadiusApplication: 'end',
            hideZeroBarsWhenGrouped: true,
            distributed: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories,
          labels: {
            style: {
              colors,
              fontSize: '12px',
            },
          },
        },
        legend: { show: false },
        tooltip: {
          enabled: true,
          intersect: true,
          hideEmptySeries: true,
          inverseOrder: true,
        },
        colors,
      },
    };
  }, [data, getLocale, t]);

  return {
    series: chartData.series,
    options: withBarSelection(chartData).options,
    label: 'Количество заказов по сотрудникам',
    subLabel: 'Количество заказов, которые были приняты каждым сотрудником за выбранный период',
    type: 'bar',
  };
};
